<div class="d-flex justify-content-between">
  <legend class="h3 mb-24px">Create Card Holding</legend>
</div>
<div class="d-flex flex-column h-100">
  <div class="detail-container h-100 d-flex flex-column">
    <h5 class="mb-32px">Selected Tickets</h5>
    <div class="row">
      <div class="col-3 detail-label">Selected Ticket</div>
      <div class="col-3 detail-value">{{ selectedTickets.length }}</div>
      <div class="col-3 detail-label">Total Amount</div>
      <div class="col-3 detail-value">{{ totalAmount | currency }}</div>
    </div>

    <div class="row h-100">
      <div class="col-12">
        <div class="h-100 w-100 pr-20px" style="position: absolute;">
          <ngx-simplebar class="table-simple-bar" id="ngxSimplebar">
            <table class="table table-list align-middle table-nowrap table-check">
              <thead>
              <tr>
                <th>Serial No</th>
                <th class="text-right">Repair Cost</th>
                <th class="text-right">Tax</th>
                <th class="text-right">Total Cost</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let ticket of selectedTickets">
                <td>{{ ticket.serialNo }}</td>
                <td class="text-right">{{ repairCost(ticket.sc4u?.pricing?.pricing, 'price')| currency }}</td>
                <td class="text-right">{{ repairCost(ticket.sc4u?.pricing?.pricing, 'tax')| currency }}</td>
                <td class="text-right">{{ ticket.cardHoldInfo?.amount || 0 | currency }}</td>
              </tr>
              </tbody>
            </table>
          </ngx-simplebar>
        </div>
      </div>
    </div>

  </div>
  <div class="detail-container h-100">
    <form (keydown.enter)="$event.preventDefault()" (ngSubmit)="submit()" [formGroup]="cardForm"
          class="sub-detail h-100">
      <div>
        <div class="mb-32px">
          <div class="d-flex">
            <h5 class="mb-24px">Credit Card Information</h5>
            <div class="pl-54px card-brands">
              <img alt="visa-image" src="../../../../../assets/img/visa.svg">
              <img alt="mastercard-image" class="ps-1" src="../../../../../assets/img/mastercard.svg">
            </div>
          </div>
          <div class="row mb-12px">
            <div class="col-2 detail-label detail-center">
              <label for="cardNumber">Number</label>
            </div>
            <div class="col-10 detail-value">
              <input autocomplete="cc-number"
                     class="form-control"
                     formControlName="cc-number"
                     id="cardNumber"
                     mask="0000 0000 0000 0000"
                     placeholder="Card Number"
                     type="text">
            </div>
          </div>
          <div class="row">
            <div class="col-2 detail-label detail-center">
              <label for="expMM">MM</label>
            </div>
            <div class="col-2 detail-value">
              <input autocomplete="cc-exp-month"
                     class="form-control"
                     formControlName="cc-exp-month"
                     id="expMM"
                     mask="00"
                     placeholder="Exp MM"
                     type="text">
            </div>
            <div class="col-2 detail-label detail-center">
              <label for="expYY">YY</label>
            </div>
            <div class="col-2 detail-value">
              <input autocomplete="cc-exp-year"
                     class="form-control"
                     formControlName="cc-exp-year"
                     id="expYY"
                     mask="00"
                     placeholder="Exp YY"
                     type="text">
            </div>
            <div class="col-2 detail-label detail-center pl-8px">
              <label for="ccv">CCV</label>
            </div>
            <div class="col-2 detail-value">
              <input autocomplete="cc-csc"
                     class="form-control"
                     formControlName="cc-csc"
                     id="ccv"
                     mask="000"
                     placeholder="CCV"
                     type="text">
            </div>
          </div>
        </div>

        <h5 class="mb-24px">Billing Information</h5>
        <div class="row mb-12px">
          <div class="col-3 detail-label">Address</div>
          <div class="col-9 detail-value">{{ billingInfo | displayAddress }}</div>
        </div>
        <div class="row">
          <div class="col-3 detail-label ">First Name</div>
          <div class="col-3 detail-value">{{ billingInfo?.firstName }}</div>
          <div class="col-3 detail-label">Last Name</div>
          <div class="col-3 detail-value">{{ billingInfo?.lastName }}</div>
        </div>
      </div>

      <div class="text-right">
        <button [disabled]="cardForm.invalid || !selectedTickets.length || !isDealer" class="btn btn-dark">Payment
        </button>
      </div>
    </form>
  </div>
</div>

